/* tslint:disable */
/* eslint-disable */
/**
 * Kiwi Framework
 * Kiwi API description
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AuthControllerRefreshAccessToken200Response
 */
export interface AuthControllerRefreshAccessToken200Response {
    /**
     * 
     * @type {string}
     * @memberof AuthControllerRefreshAccessToken200Response
     */
    accessToken?: string;
}

/**
 * Check if a given object implements the AuthControllerRefreshAccessToken200Response interface.
 */
export function instanceOfAuthControllerRefreshAccessToken200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function AuthControllerRefreshAccessToken200ResponseFromJSON(json: any): AuthControllerRefreshAccessToken200Response {
    return AuthControllerRefreshAccessToken200ResponseFromJSONTyped(json, false);
}

export function AuthControllerRefreshAccessToken200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AuthControllerRefreshAccessToken200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'accessToken': !exists(json, 'accessToken') ? undefined : json['accessToken'],
    };
}

export function AuthControllerRefreshAccessToken200ResponseToJSON(value?: AuthControllerRefreshAccessToken200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'accessToken': value.accessToken,
    };
}

